module.exports = __webpack_public_path__ + "img/homeSec01Top6.35d8e8c7.jpg";